export default __webpack_public_path__ + "static/media/circularIcon.4d50c5d8.png";